import { render, staticRenderFns } from "./UserEditDialog.vue?vue&type=template&id=4a79ccc3&scoped=true"
import script from "./UserEditDialog.vue?vue&type=script&lang=js"
export * from "./UserEditDialog.vue?vue&type=script&lang=js"
import style0 from "./UserEditDialog.vue?vue&type=style&index=0&id=4a79ccc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79ccc3",
  null
  
)

export default component.exports